<template>
	<div
		:class="`wrapper wrapper--article ${customClass}`"
		ref="wrapper"
		:shareable="articleIsShareable"
		:loading="loading"
		:is-current="isCurrent"
		:is-history="!!historyKey"
		role="article"
	>
		<UiSearch :scope="inferScope()" v-if="/-list$/.test(articleID)" />
		<BlockLoader v-else :blockContent="articleContent" style="width: 100%" ref="blockLoader" />
		<UiShare v-if="articleIsShareable" :exhibitionID="exhibitionID" :articleID="articleID" />
	</div>
</template>

<style lang="css"></style>

<script>
import { mapState, mapGetters } from 'vuex';
import { BlockLoader } from '@/tools/blockLoader';
import UiShare from './ui/share.vue';
import UiSearch from './ui/search.vue';
import { actionTypes, exhibitionTypes, articleTypes } from '@/types';
import { mapStateNested } from '@/tools/helpers';
import { SEARCH_SCOPES } from '@/tools/consts';
import logger from '@/tools/logger';

export default {
	components: {
		UiSearch,
		UiShare,
		BlockLoader,
	},
	props: {
		isCurrent: { type: Boolean },
		isInModal: { type: Boolean },
		articleID: String,
		previousArticleID: String,
		tourID: String,
		exhibitionID: String,
		historyKey: String,
		classes: Object,
		customClass: String,
	},
	data() {
		return {
			// htmlContent: '',
			loading: false,
			imageObserver: null,
		};
	},

	computed: {
		...mapState(['dataSourceURL']),
		...mapStateNested('dataSourceCFG', ['exhibitionMap']),
		...mapGetters(['getArticleContentById', 'getBlocksDevHash']),
		articleIsShareable() {
			const exhibition = this.exhibitionMap[this.exhibitionID];
			if (!exhibition) return false;
			const article = exhibition.articleMap[this.articleID];
			return article && article.isShareable;
		},
		editorApiActive() {
			return this.$store.state.editorApi.active;
		},
		articleContent() {
			const data = this.getArticleContentById(this.$props.articleID);
			if (this.editorApiActive) {
				return this.$store.state.editorApi.content ? [this.$store.state.editorApi.content] : [];
			} else {
				return data.content ? [data.content] : [];
			}
		},
	},

	watch: {
		getBlocksDevHash() {
			this.$refs.blockLoader.updateContent();
		},

		/**
		 * This watcher checks if the popertyle articleID is changing and if it loads the new content
		 */
		async articleID(newID, oldID) {
			if (newID === oldID) {
				return;
			}
			this.loadContent();
		},
		isCurrent(isCurrent, oldCurrent) {
			if (oldCurrent) {
				// force clear the swipe transform
				this.$el.style.transform = '';
			}
		},
	},
	methods: {
		// TODO: reimplent in block style
		// glossary() {
		// 	[...this.$el.querySelectorAll('.element--text')].forEach($el => {
		// 		// to Prevent highlighting the term it is own glossary term article
		// 		highlightGlossary($el, { ignoreTermKey: this.articleID });
		// 	});
		// },

		inferScope() {
			if (this.$props.exhibitionID === exhibitionTypes.root && this.articleID === 'exhibition-list')
				return SEARCH_SCOPES.exhibitions;
			if (this.$props.articleID === 'tour-list') return SEARCH_SCOPES.tours;
			if (
				this.$props.exhibitionID === exhibitionTypes.glossary &&
				this.$props.articleID === articleTypes.articleList
			)
				return SEARCH_SCOPES.glossary;
			if (this.$props.articleID.match(/^tour-/)) return SEARCH_SCOPES.tour;
			if (
				this.$props.exhibitionID === exhibitionTypes.calendar &&
				this.$props.articleID === articleTypes.articleList
			)
				return SEARCH_SCOPES.calendar;
			if (this.$props.articleID === articleTypes.articleList) return SEARCH_SCOPES.articles;
		},

		/**
		 * This method infers from route parameters the correct search scope to show correct data
		 */

		async loadContent() {
			if (!this.articleID || !this.exhibitionID) {
				logger.error(
					`Article component is created with inproper parameters articleID: ${this.articleID} exhibitionID: ${this.exhibitionID}`
				);
				return;
			}
			this.loading = true;
			await this.$store.dispatch(actionTypes.loadContent, {
				articleID: this.articleID,
				exhibitionID: this.exhibitionID,
				tourID: this.tourID,
			});
			this.loading = false;
			this.$emit('contentLoaded');
		},
	},
	mounted() {
		if (this.articleID && this.exhibitionID) {
			this.loadContent();
		}
	},
};
</script>
